import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {SergasDevice} from '../monitoredEquipment/sergasDevice';
import {SergasDeviceService} from '../monitoredEquipment/sergas-device.service';
import {I18NService} from '../../../shared/i18n/i18n.service';
import {IPlaceValuelistService} from '../../../iPlace/iPlace-valuelist.service';
import {SectionService} from '../../section/Section.service';
import {Section} from '../../section/Section';
import {NotificationsService} from 'angular2-notifications';

@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html',
  styleUrls: ['./generate-report.component.css']
})
export class GenerateReportComponent implements OnInit {

  isLoading = true;
  downloadLoading = false;

  iPlaceList:any[] = [];
  iPlaceMap:any[];
  dropdowniPlaceList:any = [];
  sections: any[] = [];

  sergasDevices: SergasDevice[] = [];
  sorts = [{prop: 'created', dir: 'desc'}];

  dropdownSergasSensorList:any = [];
  selectedSergasSensors:any = [];
  dropdownSergasSensorSettings:any = {};

  reportData: any = [];

  @ViewChild('reportForm', { static: false }) reportForm: NgForm;

  bsConfig: Partial<BsDatepickerConfig>;

  constructor(
    private i18nService: I18NService,
    private iPlaceValuelistService: IPlaceValuelistService,
    private sectionService: SectionService,
    private sergasDeviceService: SergasDeviceService,
    private notificationService: NotificationsService
  ) {

    if ( (<any>Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.iPlaceList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.iPlaceMap = this.iPlaceList.reduce((previous:any, current:any) => {
        previous[current.id] = current;
        return previous;
      }, {})
      this.dropdowniPlaceList = this.iPlaceList;
      this.getSergasSensors();
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => {
          this.iPlaceList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
            .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
          this.iPlaceMap = this.iPlaceList.reduce((previous:any, current:any) => {
            previous[current.id] = current;
            return previous;
          }, {});
          this.dropdowniPlaceList = this.iPlaceList;
          this.getSergasSensors();
        })
    }

    this.dropdownSergasSensorSettings = {
      singleSelection: false,
      enableCheckAll: true,
      enableFilterSelectAll: true,
      primaryKey: 'sergasSensorId',
      labelKey: 'description',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectSensors"),
      searchPlaceholderText: i18nService.get("search"),
      enableSearchFilter: true,
      groupBy: null,
      classes: "form-angular2-multiselect"
    };

    this.bsConfig = Object.assign({}, {containerClass: "theme-custom", showWeekNumbers: false});

    let d = new Date();
    d.setDate(d.getDate() - 7);
    this.reportData['dateRange'] = [d, new Date()]
  }

  ngOnInit() {
  }

  private getSergasSensors() {

    let filter = "iPlaceId:in:" + this.iPlaceList.map(iPlace => iPlace.idiPlace).join(",");
    let sort =  "created,desc";

    this.sergasDeviceService.getPage(0, 9999, sort, filter)
      .then(response => {
        this.sergasDevices = response.content;
        let sergasSensors = [];
        this.sergasDevices.forEach(device => sergasSensors = sergasSensors.concat(device.sergasSensors))
        this.dropdownSergasSensorList = sergasSensors;
      })
      .catch( error => {
        this.isLoading = false;
      });
  }

  onSergasSensorSelect(item: any) {
    //console.log(item);
  }

  onDeSelectAllSergasSensors(items: any) {
    //console.log(items);
  }

  generateReport() {
    if(this.reportForm.valid) {
      this.downloadLoading = true;
      this.reportForm.controls['dateRange'].value[0].setHours(0,0,0,0);
      this.reportForm.controls['dateRange'].value[1].setHours(23,59,59,999);
      let reportParams = {
        'title': this.reportForm.controls['title'].value,
        'description': this.reportForm.controls['description'].value,
        'sensors': this.selectedSergasSensors.map(sergasSensor => sergasSensor.sergasSensorId),
        'initDate': this.reportForm.controls['dateRange'].value[0].getTime(),
        'endDate': this.reportForm.controls['dateRange'].value[1].getTime(),
        'includeData': !!this.reportForm.controls['includeData'].value,
        'includeNotifications': !!this.reportForm.controls['includeNotifications'].value
      }
      this.sergasDeviceService.getReport(reportParams)
        .then(blob => {
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);
          a.href = objectUrl;
          a.download = 'report.pdf';
          a.click();
          URL.revokeObjectURL(objectUrl);
          this.downloadLoading = false;
        }).catch( error => {
        this.downloadLoading = false;
        this.notificationService.error(
          this.i18nService.get("error") ,
          this.i18nService.get("reportGenerationFailed")
        );
      });

    } else {
      Object.keys(this.reportForm.controls).forEach(key => {
        this.reportForm.controls[key].markAsDirty();
      })
    }
  }

}
